import { render, staticRenderFns } from "./RegisterComponent.vue?vue&type=template&id=0f1811c8"
import script from "./RegisterComponent.vue?vue&type=script&lang=js"
export * from "./RegisterComponent.vue?vue&type=script&lang=js"
import style0 from "./RegisterComponent.vue?vue&type=style&index=0&id=0f1811c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports